<script setup lang="ts">
import ArchiveIcon from '@/assets/icons/ArchiveIcon.vue';

defineProps<{ label?: string }>();
</script>

<template>
  <div
    :class="[
      'inline-flex items-center gap-sm',
      'min-w-0 max-w-full',
      'px-[10px] py-xs rounded-8',
      'text-on-tint bg-secondary',
    ]"
  >
    <ArchiveIcon class="w-4 h-4 shrink-0" />
    <span :title="label ?? $t('general.archive')" class="truncate">
      {{ label ?? $t('general.archive') }}
    </span>
  </div>
</template>
